import gql from 'graphql-tag';

export const GET_AGENT_PROMOS = gql`
	query GetAgentPromotions($user: String!, $limit: Int, $isActive: Boolean) {
		promos(user: $user, limit: $limit, isActive: $isActive) {
			id
			name
			promoType
			discountAmount
			discountPercentage
			discountType
			uses
			maxUses
			option {
				id
				name
			}
		}
	}
`;
